import { useQuery } from '@tanstack/react-query';
import { getTokenFields } from '../services/expressionService';
import { FieldMetadata } from '../models/expression';

export const useTokenFields = () => {
  return useQuery<FieldMetadata[]>({
    queryKey: ['token-fields'],
    queryFn: getTokenFields,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
};
